import {ResponseSerialize} from '@simpli/serialized-request'
import {IResource} from '@simpli/resource-collection/dist/types/IResource'
import {GithubUser} from '@/model/resource/GithubUser'
import {GithubRepository} from '@/model/resource/GithubRepository'

export class GithubRepositoryUser implements IResource {
  @ResponseSerialize(GithubUser)
  githubUser: GithubUser | null = null

  @ResponseSerialize(GithubRepository)
  githubRepository: GithubRepository | null = null

  contributions: number | null = null
  createdAt: Date | null = null
  updatedAt: Date | null = null

  get $id() {
    return this.githubUser?.$id ?? 0
  }

  set $id(val) {
    if (!this.githubUser) {
      this.githubUser = new GithubUser()
    }

    this.githubUser.$id = val
  }

  get $tag() {
    return String(this.$id)
  }
}
